module.exports = __webpack_public_path__ + "static/media/BlockChain.8532b653.jpg";